import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
//import "./plugins/vue2-touch-events";
import "./plugins/auth";
import "./plugins/vue-json-edit";

import "./filters/filters";

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
